import React from 'react';
import { Row, Col } from 'antd';
import { withTranslation } from 'react-i18next';
import { SectionTitle, HighlightBox } from '../../styles/checkoutStyles';
import MetricCard from './MetricCard';
import PlayoutsLabelContainer from '../../containers/step2_settings/PlayoutsLabelContainer';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDollarSign,
  faCalendarAlt,
  faStore,
  faUsers,
  faCoins,
  faDesktop,
  faEye,
  faRocket,
  faPlay,
  faRetweet,
  faUser,
  faUserPlus
} from '@fortawesome/free-solid-svg-icons';

const CampaignMetrics = ({
  campaign,
  loading,
  audienceData,
  t,
  i18n,
  subtotalCampaign,
  totalCampaign,
  currencyCampaign,
  client,
  cart,
  isCpmi
}) => {
  const { start_date, end_date } = campaign;

  const screenCount = Array.isArray(cart) ? cart.length : campaign.contents_displays_total;

  const subtotal = subtotalCampaign.toLocaleString('es-AR', {
    style: 'currency',
    currency: currencyCampaign,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const total = totalCampaign.toLocaleString('es-AR', {
    style: 'currency',
    currency: currencyCampaign,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  moment.locale(i18n.language);

  const startMoment = moment(start_date);
  const endMoment = moment(end_date);

  const format = i18n.language === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
  const startDate = startMoment.format(format);
  const endDate = endMoment.format(format);

  const diffDays = endMoment.diff(startMoment, 'days') + 1;

  // cpmi companies don't see the playouts card: the 3 impressions cards share the row equally
  const impressionsCol = isCpmi ? { xs: 24, sm: 8 } : { xs: 12, sm: 6 };

  return (
    <>
      <SectionTitle>{t('Amounts')}</SectionTitle>
      <HighlightBox type="flex">
        <Col xs={24} sm={12} style={{ padding: 0 }}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faDollarSign} />}
            value={subtotal}
            label={t('Subtotal')}
          />
        </Col>
        <Col xs={24} sm={12} style={{ padding: 0 }}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faDollarSign} />}
            value={total}
            label={t('Total budget')}
          />
        </Col>
      </HighlightBox>

      <SectionTitle>{t('Campaign details')}</SectionTitle>
      <Row gutter={[16, 16]} type="flex">
        <Col xs={24} sm={12}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faCalendarAlt} />}
            value={`${diffDays} ${t('days')} (${startDate} - ${endDate})`}
            label={t('Dates')}
          />
        </Col>
        <Col xs={24} sm={12}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faStore} />}
            value={client.name}
            label={t('Client')}
          />
        </Col>
      </Row>

      <Row type="flex" gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col {...impressionsCol}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faRocket} />}
            value={loading ? '...' : audienceData.potential_reach}
            label={t('Planned impressions (%)')}
            tooltip={t('Planned impressions percentage tooltip')}
          />
        </Col>
        <Col {...impressionsCol}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faUserPlus} />}
            value={loading ? '...' : audienceData.reach}
            label={t('Max. available imp.')}
            tooltip={t('Maximum available impressions tooltip')}
          />
        </Col>
        <Col {...impressionsCol}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faUsers} />}
            value={loading ? '...' : audienceData.impacts}
            label={t('Audience impressions')}
          />
        </Col>
        {!isCpmi && (
          <Col xs={12} sm={6}>
            <MetricCard
              icon={<FontAwesomeIcon icon={faPlay} />}
              value={loading ? '...' : audienceData.total_exits}
              label={<PlayoutsLabelContainer />}
            />
          </Col>
        )}
      </Row>

      <Row gutter={[16, 16]} type="flex" style={{ marginTop: '16px' }}>
        <Col xs={12} sm={6}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faDesktop} />}
            value={screenCount}
            label={t('Screens')}
          />
        </Col>
        <Col xs={12} sm={6}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faCoins} />}
            value={loading ? '...' : audienceData.average_cpm}
            label={t('CPM Average')}
          />
        </Col>
        <Col xs={12} sm={6}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faRetweet} />}
            value={loading ? '...' : audienceData.frequency_of_unique_individuals}
            label={t('Unique people frequency')}
          />
        </Col>
        <Col xs={12} sm={6}>
          <MetricCard
            icon={<FontAwesomeIcon icon={faUser} />}
            value={loading ? '...' : audienceData.total_unique_impacts}
            label={t('Projected reach')}
            tooltip={t('Projected reach tooltip')}
          />
        </Col>
      </Row>
    </>
  );
};

export default withTranslation()(CampaignMetrics);
